import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CaregiverCertification } from "src/messages";

export interface CertificationState {
    selectedCertification: CaregiverCertification | null;
    agencyCertifications: CaregiverCertification[];
}

const CertificationSliceInitialState: CertificationState = {
    selectedCertification: null,
    agencyCertifications: []
};

const certificationSlice = createSlice({
      name: "certifications",
      initialState: CertificationSliceInitialState,
      reducers: {
        setAgencyCertifications: (state, action: PayloadAction<CaregiverCertification[]> ) => { state.agencyCertifications = action.payload; },
        setSelectedCertification: (state, action: PayloadAction<CaregiverCertification | null> ) => { state.selectedCertification = action.payload; }
      }
  });

export const {
  setAgencyCertifications: setAgencyCertificationsActionCreator,
  setSelectedCertification: setCertificationActionCreator,
} = certificationSlice.actions;
export default certificationSlice.reducer;



// WEBPACK FOOTER //
// ./src/store/slices/certificationsSlice.ts